// extracted by mini-css-extract-plugin
export default {"error":"lU5IL1tPkHYbvFvwMB2w"};